import { Component, EventEmitter, Output } from '@angular/core';
import { ToolbarType } from '../../../services/lineup-service';

@Component({
  selector: 'toolbar-tshirt',
  templateUrl: 'toolbar-tshirt.html',
  styleUrls:['./toolbar-tshirt.scss']
})
export class ToolbarTshirtComponent {
  @Output() onTypeSelected = new EventEmitter<ToolbarType>();
  @Output() onAddPlayer = new EventEmitter<ToolbarType>();

  onCloseClick() {
    this.onTypeSelected.emit(ToolbarType.main)
  }

  onAddPlayerClick() {
    this.onAddPlayer.emit();
  }
}


